import { Providers } from './providers'
import { AppRouter } from './router'
import { ArcElement, BarController, BarElement, CategoryScale, Chart as ChartJS, Filler, Legend, LinearScale, LineController, LineElement, PointElement, TimeScale, Tooltip, DoughnutController } from 'chart.js';
import Modal from 'react-modal'
import { registerLocale, setDefaultLocale } from 'react-datepicker';
import { ru } from 'date-fns/locale';
import './styles/global.scss'

/* chart.js */
import 'chartjs-adapter-date-fns'
ChartJS.register(CategoryScale, LinearScale, PointElement, LineController, LineElement, ArcElement, BarElement, BarController, Legend, Tooltip, Filler, TimeScale, DoughnutController);

/* react-modal */
Modal.setAppElement('#root');

/* react-datepicker */
registerLocale('ru', ru)
setDefaultLocale('ru')

const App = () => {
   return (
      <Providers>
         <div id='app' className="App">
            <AppRouter />
         </div>
      </Providers>
   )
}

export default App
